import getDirectusInstance from '$lib/directus';
import type { Fetch } from '$lib/Fetch';
import { PicpeccAuth } from '$lib/PicpeccAuth';
import type { AuthenticationClient, DirectusClient, RestClient } from '@directus/sdk';
import { MeService } from './MeService';

export interface ApplicationServices {
	auth: PicpeccAuth;
	directus: DirectusClient<any> & AuthenticationClient<any> & RestClient<any>;
	meService: MeService;
}

let servicesSingleton: ApplicationServices | null = null;

export async function getApplicationServices(
	fetch: Fetch,
	oneTimeSetup: (services: ApplicationServices) => void
): Promise<ApplicationServices> {
	if (servicesSingleton) {
		return servicesSingleton;
	}

	const directus = await getDirectusInstance(fetch);
	const auth = new PicpeccAuth(directus);
	const meService = new MeService(directus, auth.onIsLoggedInChanged);

	servicesSingleton = {
		directus,
		auth,
		meService
	};

	oneTimeSetup(servicesSingleton);

	return servicesSingleton;
}
